import { isNoAuthLayoutPath } from "@/layouts/utils";

export function buildLoginRedirectPath(targetPath: string): string {
  return `/login?redirect=${encodeURIComponent(targetPath)}`;
}

/**
 * 接口返回未授权（code=1）时，当前路径是否允许匿名停留。
 * 免登录公开页面（noAuthLayoutPaths）不应被全局未授权处理强制踢回旧版首页。
 */
export function shouldAllowAnonymousStayOnUnAuth(pathname: string): boolean {
  return isNoAuthLayoutPath(pathname);
}

export function resolveSafeLoginRedirect(redirect: string | null): string | null {
  const target = redirect?.trim();
  if (!target) return null;
  if (!target.startsWith("/") || target.startsWith("//")) return null;
  if (target.includes("://") || target.includes("\\")) return null;
  return target;
}
